export default __webpack_public_path__ + "static/media/devices.60894ac8.svg";